import styled from 'styled-components';
import cn from 'classnames';
import { Close } from '@mui/icons-material';

import MyPageNav from '../common/MyPageNav';
import { useHistory } from 'react-router-dom';
import tokenLib from '../../library/token.lib';

type FavoriteProps = {
  favorite_product_list: any[];
  handleFavorite: (id: string) => void;
};

export default function Favorite({
  favorite_product_list,
  handleFavorite,
}: FavoriteProps) {
  const history = useHistory();

  return (
    <MyPageNav>
      <Box>
        {favorite_product_list.map((data, index) => {
          return (
            <div key={index} className={cn('item')}>
              <div
                className={cn('item-icon_wrap')}
                onClick={() => handleFavorite(data.id)}
              >
                <Close className={cn('item-icon_wrap-icon')} />
              </div>

              <img
                className={cn('item-img')}
                src={data.image_list[0].image}
                alt='item_img'
                onClick={() => history.push(`/product/${data.id}`)}
              />

              <span
                className={cn('item-brand')}
                onClick={() => history.push(`/product/${data.id}`)}
              >
                {data.brand.name}
              </span>

              <span
                className={cn('item-product')}
                onClick={() => history.push(`/product/${data.id}`)}
              >
                {data.name}
              </span>

              <span
                className={cn('item-sign')}
                onClick={() => {
                  if (!tokenLib.getRefreshToken()) history.push('/sign');
                }}
              >
                {!tokenLib.getRefreshToken()
                  ? 'Login or Register to buy'
                  : tokenLib.getCountry() === 'guam'
                  ? `$${Number(data.guam_original_price).toLocaleString()}`
                  : `$${Number(data.saipan_original_price).toLocaleString()}`}
              </span>
            </div>
          );
        })}
      </Box>
    </MyPageNav>
  );
}

const Box = styled.div`
  width: 100%;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(auto-fill, 480px);
  row-gap: 40px;
  column-gap: 20px;

  .item {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 20px;
    border: 1px solid #dbdbdb;

    &-icon_wrap {
      width: 38px;
      height: 38px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 20px;
      left: calc(100% - 58px);
      border-radius: 5px;
      background-color: #344b42;
      cursor: pointer;

      &-icon {
        width: 70%;
        height: auto;
        fill: #fff;
      }
    }

    &-img {
      width: 100%;
      height: 300px;
      object-fit: cover;
      object-position: center;
      margin-bottom: 20px;
      cursor: pointer;
    }

    &-brand {
      font-weight: 600;
      margin-bottom: 10px;
      cursor: pointer;
      user-select: none;
      font-family: 'Merriweather';
    }

    &-product {
      font-size: 20px;
      margin-bottom: 10px;
      cursor: pointer;
      user-select: none;
      font-family: 'Oswald';
    }

    &-sign {
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
